<template>
	<div class="main content__container">
		<YearNavigator></YearNavigator>
		<MediaTabs></MediaTabs>
		<transition name="modal">
			<ImageModal></ImageModal>
		</transition>
		<div class="feed__container">
			<transition-group name="fade-up" class="posts__list" tag="ul">
				<li v-for="(post, index) in posts" :key="post._id">
					<BasePost :post="post" :number="++index"> </BasePost>
					<span class="posts__separator" v-if="checkDate(index)">
						{{ checkDate(index) }}
					</span>
				</li>
			</transition-group>
			<div class="spinner__container flex" v-if="loading">
				<Spinner :size="60" :color="'#3897f0'"></Spinner>
			</div>
		</div>
		<span ref="trigger"></span>
	</div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import BasePost from "@/components/BasePost";
import ImageModal from "@/components/TheImageModal";
import YearNavigator from "@/components/TheYearNavigator";
import MediaTabs from "@/components/TheMediaTabs";

export default {
	components: {
		BasePost,
		ImageModal,
		YearNavigator,
		MediaTabs,
	},
	data() {
		return {
			bottom: false,
			observer: null,
		};
	},
	created() {
		const payload = {
			page: null,
			year: true,
		};

		this.$store.dispatch("resetState", payload);
		this.$store.dispatch("loadPosts");
		this.$store.dispatch("getYears");
	},
	mounted() {
		this.checkBottom();
	},
	computed: {
		...mapState(["posts", "loading", "pageType"]),
	},
	methods: {
		...mapActions(["loadTaggedPosts", "loadYearPosts", "loadPosts"]),
		checkBottom() {
			this.observer = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						this.startLoad();
					}
				});
			});

			this.observer.observe(this.$refs.trigger);
		},
		startLoad() {
			clearTimeout(timeout);

			let timeout = setTimeout(() => {
				if (!this.loading) {
					const page = this.pageType;

					switch (page) {
						case "tags":
							this.loadTaggedPosts;
							break;
						case "year":
							this.loadYearPosts(this.$store.state.year);
							break;
						default:
							this.loadPosts;
					}
				}
			}, 200);
		},
		checkDate(num) {
			if (this.posts[num + 1] != undefined) {
				if (this.posts[num].year > this.posts[num + 1].year) {
					return this.posts[num + 1].year;
				}
			}
		},
	},
};
</script>
